import helper from "../helper";
// import user from "../store/modules/user";

let getSurveyUrl = helper.getSurveyUrlWithParameters

export default {
    getSurveyUrl,
    getByRecievedUrlData: (url, gets = null) => getSurveyUrl(
        url.basename,
        url.action,
        url.params,
        gets
    ),
    ADMIN: {
        SURVEY: {
            LIST:
              /**
               * Получает URL для списка опросов
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения списка опросов
               */
                (gets = null) => getSurveyUrl(
                    'surveys|admin_survey|survey-list',
                    "list",
                    gets
                ),
            DETAIL:
              /**
               * Получает URL для детальной информации об опросе
               * @param {number} id - Идентификатор опроса
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения детальной информации
               */
                (id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|survey-detail',
                    "retrieve",
                    {id: id},
                    gets
                ),
            EDIT:
              /**
               * Получает URL для редактирования опроса
               * @param {number} id - Идентификатор опроса
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для частичного обновления опроса
               */
                (id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|survey-detail',
                    "partial_update",
                    {id: id},
                    gets
                ),
            DUPLICATE:
              /**
               * Получает URL для дублирования опроса
               * @param {number} id - Идентификатор опроса для дублирования
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для создания копии опроса
               */
                (id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|survey-duplicate',
                    "duplicate",
                    {id: id},
                    gets
                ),
            DELETE:
              /**
               * Получает URL для удаления опроса
               * @param {number} id - Идентификатор опроса для удаления
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для удаления опроса
               */
                (id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|survey-detail',
                    "destroy",
                    {id: id},
                    gets
                ),
        },
        KIND_PARAM: {
            GET_KIND_PARAM:
              /**
               * Получает URL для получения параметров типа с поиском
               * @param {number} id - Идентификатор опроса
               * @param {Object} gets - Query-параметры (search, фильтры)
               * @returns {string} URL для поиска параметров типа
               */
                (id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|survey-get-kind-param',
                    "get_kind_param",
                    {id: id},
                    gets
                ),
            LIST:
              /**
               * Получает URL для списка всех параметров типа
               * @param {number} survey_id - Идентификатор опроса
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения списка параметров
               */
                (survey_id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|kind_param-list',
                    "list",
                    {survey_id: survey_id},
                    gets
                ),
            CREATE:
              /**
               * Получает URL для создания нового параметра типа
               * @param {number} survey_id - Идентификатор опроса
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для создания параметра
               */
                (survey_id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|kind_param-list',
                    "create",
                    {survey_id: survey_id},
                    gets
                ),
            DELETE:
              /**
               * Получает URL для удаления параметра типа
               * @param {number} survey_id - Идентификатор опроса
               * @param {number} id - Идентификатор параметра
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для удаления параметра
               */
                (survey_id, id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|kind_param-detail',
                    "destroy",
                    {
                        survey_id: survey_id,
                        id: id,
                    },
                    gets
                ),
            DELETEALL:
              /**
               * Получает URL для удаления всех параметров типа
               * @param {number} survey_id - Идентификатор опроса
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для массового удаления параметров
               */
                (survey_id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|kind_param_all',
                    "delete",
                    {
                        survey_id: survey_id,
                    },
                    gets
                ),
        },
        INVITE: {
            LIST:
              /**
               * Получает URL для списка персональных приглашений
               * @param {number} survey_id - Идентификатор опроса
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения списка приглашений
               */
                (survey_id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|invite-list',
                    "list",
                    {survey_id: survey_id},
                    gets
                ),
            CREATE:
              /**
               * Получает URL для создания нового приглашения
               * @param {number} survey_id - Идентификатор опроса
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для создания приглашения
               */
                (survey_id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|invite-list',
                    "create",
                    {survey_id: survey_id},
                    gets
                ),
            DETAIL:
              /**
               * Получает URL для детальной информации о приглашении
               * @param {number} survey_id - Идентификатор опроса
               * @param {number} id - Идентификатор приглашения
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения деталей приглашения
               */
                (survey_id, id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|invite-detail',
                    "retrieve",
                    {
                        survey_id: survey_id,
                        id: id
                    },
                    gets
                ),
            DELETE:
              /**
               * Получает URL для удаления приглашения
               * @param {number} survey_id - Идентификатор опроса
               * @param {number} id - Идентификатор приглашения
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для удаления приглашения
               */
                (survey_id, id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|invite-detail',
                    "destroy",
                    {
                        survey_id: survey_id,
                        id: id
                    },
                    gets
                ),
            SEND:
              /**
               * Получает URL для отправки email-приглашений
               * @param {number} id - Идентификатор опроса
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для массовой отправки приглашений
               */
                (id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|survey-send-invite',
                    "send_invite",
                    {id: id},
                    gets
                ),
        },
        FILE: {
            UNLODING:
              /**
               * Получает URL для выгрузки статистических файлов
               * @param {number} id - Идентификатор опроса
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для загрузки файла статистики
               */
                (id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|survey-need-unloading',
                    "need_unloading",
                    {id: id},
                    gets
                ),
        },
        STAGE: {
            LIST:
              /**
               * Получает URL для списка этапов опроса
               * @param {number} survey_id - Идентификатор опроса
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения списка этапов
               */
                (survey_id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|stage-list',
                    "list",
                    {survey_id: survey_id},
                    gets
                ),
            SAVE:
              /**
               * Получает URL для создания нового этапа
               * @param {number} survey_id - Идентификатор опроса
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для создания этапа
               */
                (survey_id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|stage-list',
                    "create",
                    {survey_id: survey_id},
                    gets
                ),
            EDIT:
              /**
               * Получает URL для редактирования этапа
               * @param {number} survey_id - Идентификатор опроса
               * @param {number} id - Идентификатор этапа
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для частичного обновления этапа
               */
                (survey_id, id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|stage-detail',
                    "partial_update",
                    {
                        survey_id: survey_id,
                        id: id},
                    gets
                ),
            COPY:
              /**
               * Получает URL для копирования этапа
               * @param {number} survey_id - Идентификатор опроса
               * @param {number} id - Идентификатор этапа для копирования
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для создания копии этапа
               */
                (survey_id, id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|stage-copy',
                    "copy",
                    {
                        survey_id: survey_id,
                        id: id},
                    gets
                ),
            DELETE:
              /**
               * Получает URL для удаления этапа
               * @param {number} survey_id - Идентификатор опроса
               * @param {number} id - Идентификатор этапа
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для удаления этапа
               */
                (survey_id, id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|stage-detail',
                    "destroy",
                    {
                        survey_id: survey_id,
                        id: id},
                    gets
                ),
        },
        STAGE_FIELDS: {
            LIST:
              /**
               * Получает URL для списка полей этапа
               * @param {number} survey_id - Идентификатор опроса
               * @param {number} stage_id - Идентификатор этапа
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения полей этапа
               */
                (survey_id, stage_id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|stage_field-list',
                    "list",
                    {
                        survey_id: survey_id,
                        stage_id: stage_id
                    },
                    gets
                ),
            CREATE:
              /**
               * Получает URL для создания нового поля в этапе
               * @param {number} survey_id - Идентификатор опроса
               * @param {number} stage_id - Идентификатор этапа
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для создания поля
               */
                (survey_id, stage_id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|stage_field-list',
                    "create",
                    {
                        survey_id: survey_id,
                        stage_id: stage_id
                    },
                    gets
                ),
            EDIT:
              /**
               * Получает URL для редактирования поля этапа
               * @param {number} survey_id - Идентификатор опроса
               * @param {number} stage_id - Идентификатор этапа
               * @param {number} id - Идентификатор поля
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для частичного обновления поля
               */
                (survey_id, stage_id, id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|stage_field-detail',
                    "partial_update",
                    {
                        survey_id: survey_id,
                        stage_id: stage_id,
                        id: id
                    },
                    gets
                ),
            DELETE:
              /**
               * Получает URL для удаления поля из этапа
               * @param {number} survey_id - Идентификатор опроса
               * @param {number} stage_id - Идентификатор этапа
               * @param {number} id - Идентификатор поля
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для удаления поля
               */
                (survey_id, stage_id, id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|stage_field-detail',
                    "destroy",
                    {
                        survey_id: survey_id,
                        stage_id: stage_id,
                        id: id
                    },
                    gets
                ),
        },
        FIELDS: {
            LIST:
              /**
               * Получает URL для списка всех полей
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения списка полей
               */
                (survey_id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|field-list',
                    "list",
                    gets
                ),
            SAVE:
              /**
               * Получает URL для создания нового поля
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для создания поля
               */
                (survey_id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|field-list',
                    "create",
                    gets
                ),
            EDIT:
              /**
               * Получает URL для редактирования поля
               * @param {number} id - Идентификатор поля
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для частичного обновления поля
               */
                (id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|field-detail',
                    "partial_update",
                    {id: id},
                    gets
                ),
            DETAIL:
              /**
               * Получает URL для детальной информации о поле
               * @param {number} id - Идентификатор поля
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения деталей поля
               */
                (id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|field-detail',
                    "retrieve",
                    {id: id},
                    gets
                ),
            DELETE:
              /**
               * Получает URL для удаления поля
               * @param {number} id - Идентификатор поля
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для удаления поля
               */
                (id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|field-detail',
                    "destroy",
                    {id: id},
                    gets
                ),
        },
        CHOICES: {
            LIST:
              /**
               * Получает URL для списка вариантов выбора
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения списка вариантов
               */
                (gets = null) => getSurveyUrl(
                    'surveys|admin_survey|value_choices-list',
                    "list",
                    gets
                ),
            SAVE:
              /**
               * Получает URL для создания нового варианта выбора
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для создания варианта
               */
                (gets = null) => getSurveyUrl(
                    'surveys|admin_survey|value_choices-list',
                    "create",
                    gets
                ),
            EDIT:
              /**
               * Получает URL для редактирования варианта выбора
               * @param {number} id - Идентификатор варианта
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для частичного обновления варианта
               */
                (id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|value_choices-detail',
                    "partial_update",
                    {id: id},
                    gets
                ),
            DETAIL:
              /**
               * Получает URL для детальной информации о варианте выбора
               * @param {number} id - Идентификатор варианта
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения деталей варианта
               */
                (id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|value_choices-detail',
                    "retrieve",
                    {id: id},
                    gets
                ),
            DELETE:
              /**
               * Получает URL для удаления варианта выбора
               * @param {number} id - Идентификатор варианта
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для удаления варианта
               */
                (id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|value_choices-detail',
                    "destroy",
                    {id: id},
                    gets
                ),
        },
        CHOICE_VALUE: {
            LIST:
              /**
               * Получает URL для списка значений варианта выбора
               * @param {number} value_choices_id - Идентификатор родительского варианта
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения значений
               */
                (value_choices_id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|value_choice-list',
                    "list",
                    {value_choices_id: value_choices_id},
                    gets
                ),
            ONE_CREATE:
              /**
               * Получает URL для создания одного значения
               * @param {number} value_choices_id - Идентификатор родительского варианта
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для создания значения
               */
                (value_choices_id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|value_choice-list',
                    "create",
                    {value_choices_id: value_choices_id},
                    gets
                ),
            MANY_CREATE:
              /**
               * Получает URL для массового создания значений
               * @param {number} id - Идентификатор родительского варианта
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для массового сохранения значений
               */
                (id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|value_choices-many-value-choice-save',
                    "many_value_choice_save",
                    {id: id},
                    gets
                ),
            EDIT:
              /**
               * Получает URL для редактирования значения
               * @param {number} value_choices_id - Идентификатор родительского варианта
               * @param {number} id - Идентификатор значения
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для частичного обновления значения
               */
                (value_choices_id, id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|value_choice-detail',
                    "partial_update",
                    {
                        value_choices_id: value_choices_id,
                        id: id
                    },
                    gets
                ),
            DETAIL:
              /**
               * Получает URL для детальной информации о значении
               * @param {number} value_choices_id - Идентификатор родительского варианта
               * @param {number} id - Идентификатор значения
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения деталей значения
               */
                (value_choices_id, id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|value_choice-detail',
                    "retrieve",
                    {
                        value_choices_id: value_choices_id,
                        id: id
                    },
                    gets
                ),
            DELETE:
              /**
               * Получает URL для удаления значения
               * @param {number} value_choices_id - Идентификатор родительского варианта
               * @param {number} id - Идентификатор значения
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для удаления значения
               */
                (value_choices_id, id, gets = null) => getSurveyUrl(
                    'surveys|admin_survey|value_choice-detail',
                    "destroy",
                    {
                        value_choices_id: value_choices_id,
                        id: id
                    },
                    gets
                ),
        },
        USER: {
            LIST:
              /**
               * Получает URL для списка пользователей
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения списка пользователей
               */
                (gets = null) => getSurveyUrl(
                    'surveyings|admin_user|local_user-list',
                    "list",
                    gets
                ),
            SAVE:
              /**
               * Получает URL для создания нового пользователя
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для создания пользователя
               */
                (gets = null) => getSurveyUrl(
                    'surveyings|admin_user|local_user-list',
                    "create",
                    gets
                ),
            EDIT:
              /**
               * Получает URL для редактирования пользователя
               * @param {number} id - Идентификатор пользователя
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для частичного обновления пользователя
               */
                (id, gets = null) => getSurveyUrl(
                    'surveyings|admin_user|local_user-detail',
                    "partial_update",
                    {id: id},
                    gets
                ),
            DETAIL:
              /**
               * Получает URL для детальной информации о пользователе
               * @param {number} id - Идентификатор пользователя
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения деталей пользователя
               */
                (id, gets = null) => getSurveyUrl(
                    'surveyings|admin_user|local_user-detail',
                    "retrieve",
                    {id: id},
                    gets
                ),
            DELETE:
              /**
               * Получает URL для удаления пользователя
               * @param {number} id - Идентификатор пользователя
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для удаления пользователя
               */
                (id, gets = null) => getSurveyUrl(
                    'surveyings|admin_user|local_user-detail',
                    "destroy",
                    {id: id},
                    gets
                ),
        },
        ATTEMPTS: {
          LIST:
            /**
             * Получает URL для списка попыток
             * @param {Object} gets - Query-параметры
             * @returns {string} URL для получения списка попыток
             */
            (id, gets = null) => getSurveyUrl(
              'attempts|admin_attempt|attempt-list',
              "list",
              {},
              gets
            ),
          DETAIL:
            /**
             * Получает URL для детальной информации о попытке
             * @param {number} id - Идентификатор попытки
             * @param {Object} gets - Query-параметры
             * @returns {string} URL для получения деталей попытки
             */
            (id, gets = null) => getSurveyUrl(
              'attempts|admin_attempt|attempt-detail',
              "retrieve",
              {id: id},
              gets
            ),
          STAGES: {
            LIST:
              /**
               * Получает URL для списка этапов попытки
               * @param {number} attempt_id - Идентификатор попытки
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения этапов попытки
               */
              (attempt_id, gets = null) => getSurveyUrl(
              'attempts|admin_attempt|stage-list',
              "list",
              {attempt_id: attempt_id},
              gets
            ),
            FIELDS:
              /**
               * Получает URL для полей этапа попытки
               * @param {number} attempt_id - Идентификатор попытки
               * @param {number} stage_id - Идентификатор этапа
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения полей этапа
               */
              (attempt_id, stage_id, gets = null) => getSurveyUrl(
              'attempts|admin_attempt|stage_field-list',
              'list',
              {
                attempt_id: attempt_id,
                stage_id: stage_id
              },
              gets
            ),
          },
          DELETE:
            /**
             * Получает URL для удаления попытки
             * @param {number} id - Идентификатор попытки
             * @param {Object} gets - Query-параметры
             * @returns {string} URL для удаления попытки
             */
              (id, gets = null) => getSurveyUrl(
                  'attempts|admin_attempt|attempt-detail',
                  "destroy",
                  {id: id},
                  gets
              ),
        },
        CHOICES_CONST: {
            TYPES:
              /**
               * Получает URL для получения типов полей
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения справочника типов полей
               */
                (gets = null) => getSurveyUrl(
                    'surveys|choices|field_type_choices',
                    "get",
                    gets
                ),
        },
    },
}
